import { t } from 'i18next';
import { SpeakerTestButton } from 'features/SpeakerTest/SpeakerTestButton';
import { SoundAndCameraSettingsMenuItem } from 'features/Modals/SoundSettingsModal/components/SoundAndCameraSettingsMenuItem/SoundAndCameraSettingsMenuItem';
import { VolumeIndicator } from 'features/VolumeIndicator/components/VolumeIndicator/VolumeIndicator';
import { MenuItem } from '../ControlButtonMenu/ControlButtonMenu';

export type DeviceKind = 'audioinput' | 'audiooutput';

interface ExcludeDefaultDeviceProps {
    devices: MediaDeviceInfo[];
    currentDeviceId?: string;
    kind: DeviceKind;
}

interface BuildMenuProps {
    isAdvanced: boolean;
    audioInputDevices: MediaDeviceInfo[];
    audioOutputDevices: MediaDeviceInfo[];
    audioInputDeviceId?: string;
    audioOutputDeviceId?: string;
}

const getDevicesWithActiveStatus = ({ devices, currentDeviceId, kind }: ExcludeDefaultDeviceProps) => {
    return devices
        .filter(({ deviceId }) => deviceId !== 'default')
        .map(({ deviceId, label }, i) => {
            // В Chrome есть устройство по-умолчанию, неявно выбрано оно.
            const isDefault = !currentDeviceId || currentDeviceId === 'default';
            // Браузеры неявно выбирают первое устройство в списке.
            const isFirstDevice = i === 0;
            const isNotDefaultDeviceActive = deviceId === currentDeviceId;
            const active = isDefault ? isFirstDevice : isNotDefaultDeviceActive;

            return { type: 'label', text: label, active, kind };
        });
};

export const buildMenu = ({
    isAdvanced,
    audioInputDevices,
    audioOutputDevices,
    audioInputDeviceId,
    audioOutputDeviceId,
}: BuildMenuProps) => {
    // Убираем устройство default(Chrome), и корректно показываем выбранное устройство
    const audioInputMenuItems = getDevicesWithActiveStatus({
        devices: audioInputDevices,
        currentDeviceId: audioInputDeviceId,
        kind: 'audioinput',
    });
    const audioOutputMenuItems = getDevicesWithActiveStatus({
        devices: audioOutputDevices,
        currentDeviceId: audioOutputDeviceId,
        kind: 'audiooutput',
    });

    if (isAdvanced) {
        return [
            ...(audioInputMenuItems.length > 0
                ? [
                      { type: 'title', text: t('vks_microphone_microphone') },
                      ...audioInputMenuItems,
                      { type: 'element', element: VolumeIndicator },
                  ]
                : []),
            ...(audioOutputMenuItems.length > 0
                ? [
                      { type: 'title', text: t('vks_microphone_audio_output'), withSeparator: true },
                      ...audioOutputMenuItems,
                      { type: 'element', element: SpeakerTestButton },
                  ]
                : []),
            {
                type: 'menu',
                element: SoundAndCameraSettingsMenuItem,
                fullWidth: true,
                withSeparator: audioInputMenuItems.length > 0 || audioOutputMenuItems.length > 0,
            },
        ].filter(Boolean) as MenuItem[];
    }

    return [...(audioInputMenuItems.length > 0 ? audioInputMenuItems : [])].filter(Boolean) as MenuItem[];
};
